const skills = [
  { name: "JavaScript", level: 90 },
  { name: "TypeScript", level: 80 },
  { name: "React.js", level: 85 },
  { name: "React Native", level: 70 },
  { name: "Next.js", level: 80 },
  { name: "CSS  / Tailwind CSS", level: 85 },
  { name: "Node.js", level: 90 },
  { name: "Express.js", level: 90 },
  { name: "MongoDB", level: 80 },
  { name: "REST APIs", level: 90 },
  { name: "Git / GitHub", level: 85 },
  { name: "SharePoint Framework (SPFx)", level: 70 },
  { name: "Storybook", level: 70 },
  { name: "Playwright", level: 65 },
  { name: "n8n workflows automation", level: 80 },
];
const SkillsSection = () => {
  return (
    <section className="mt-12">
      <header>
        <h2 className="text-xl font-bold text-mint-700 dark:text-riptide-300">
          Skills
        </h2>
        <div className="h-1 w-10 bg-mint-500 dark:bg-riptide-400 rounded-full mt-2 mb-6"></div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {skills.map((skill) => (
          <div key={skill.name}>
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium text-gray-800 dark:text-gray-200">
                {skill.name}
              </span>
              <span className="text-sm text-mint-900 dark:text-riptide-300">
                {skill.level}%
              </span>
            </div>
            <div className="w-full bg-mint-100 dark:bg-zinc-700 rounded-full h-3">
              <div
                className="bg-mint-300 dark:bg-riptide-600 h-3 rounded-full transition-all duration-700 ease-out"
                style={{ width: `${skill.level}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SkillsSection;
